import {
  Button,
  ButtonGroup,
  ButtonList,
  DropdownButton,
  DropdownButtonContext,
} from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { User } from 'lib-shared-types-api';

import { openComposeEmail } from 'app/components/appModals/components/composeEmailModal/openComposeEmail';
// eslint-disable-next-line no-restricted-imports
import { EmailUser } from 'components/shared/composeEmail/components/ComposeEmailModal';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

import styles from './contactEmail.module.scss';

interface ContactEmailActionProps {
  user: User;
}

export function ContactEmailAction({
  user,
}: ContactEmailActionProps): JSX.Element {
  const dispatch = useAppDispatch();

  const handleClick = (email: string | null) => {
    if (!email) return;

    const toUser: EmailUser[] = [
      {
        user: {
          ...user,
          ...(user.name && { display_name: user.name }),
          ...(email && { email }),
        },
      },
    ];

    // Dispatch in next animation frame to avoid blur when the modal is opened
    requestAnimationFrame(() => {
      dispatch(openComposeEmail({ initialValues: { toUser } }));
    });

    ampli.contactsCardComposeNewEmailClicked();
  };

  return (
    <ButtonGroup variant="secondary">
      <Button icon="mail" onClick={() => handleClick(user.email)}>
        Email
      </Button>
      {user.additional_emails && (
        <DropdownButton
          icon="angle-down"
          buttonProps={{
            className: styles.dropdownButton,
          }}
          dropdown={
            <DropdownButtonContext.Consumer>
              {({ toggleDropdown }) => (
                <ButtonList>
                  <ButtonList.Item
                    onClick={() => {
                      toggleDropdown();
                      handleClick(user.email);
                    }}
                  >
                    {user.email}
                  </ButtonList.Item>
                  {user.additional_emails?.map((option) => (
                    <ButtonList.Item
                      key={option}
                      onClick={() => {
                        toggleDropdown();
                        handleClick(option);
                      }}
                    >
                      {option}
                    </ButtonList.Item>
                  ))}
                </ButtonList>
              )}
            </DropdownButtonContext.Consumer>
          }
        />
      )}
    </ButtonGroup>
  );
}
